var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "600pt",
    height: "600pt",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 172 10 L 405 10 L 405 505 L 172 505 Z M 172 10 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 286.082031 16.417969 L 16.414063 286.085938 C 8.730469 293.769531 8.730469 306.230469 16.414063 313.917969 L 286.082031 583.582031 C 293.769531 591.269531 306.230469 591.269531 313.914063 583.582031 L 583.582031 313.917969 C 591.269531 306.230469 591.269531 293.769531 583.582031 286.085938 L 313.914063 16.417969 C 310.074219 12.574219 305.035156 10.652344 300 10.652344 C 294.964844 10.652344 289.925781 12.574219 286.082031 16.417969 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.999023%,34.498596%,64.299011%)",
      fillOpacity: 1
    },
    d: "M 300 584.347656 C 296.078125 584.347656 292.390625 582.820313 289.617188 580.046875 L 19.953125 310.382813 C 14.226563 304.65625 14.226563 295.34375 19.953125 289.617188 L 289.617188 19.953125 C 292.390625 17.179688 296.078125 15.652344 300 15.652344 C 303.921875 15.652344 307.605469 17.179688 310.378906 19.953125 L 580.046875 289.617188 C 582.820313 292.390625 584.347656 296.078125 584.347656 300 C 584.347656 303.921875 582.820313 307.609375 580.046875 310.382813 L 310.382813 580.046875 C 307.605469 582.820313 303.921875 584.347656 300 584.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 300 10.652344 C 294.964844 10.652344 289.925781 12.574219 286.082031 16.414063 L 16.417969 286.082031 C 8.730469 293.769531 8.730469 306.230469 16.417969 313.917969 L 286.082031 583.582031 C 289.925781 587.425781 294.964844 589.347656 300 589.347656 C 305.035156 589.347656 310.074219 587.425781 313.917969 583.582031 L 583.582031 313.917969 C 591.269531 306.230469 591.269531 293.769531 583.582031 286.082031 L 313.917969 16.414063 C 310.074219 12.574219 305.035156 10.652344 300 10.652344 M 300 20.652344 C 302.585938 20.652344 305.015625 21.660156 306.847656 23.488281 L 576.511719 293.152344 C 580.285156 296.929688 580.285156 303.070313 576.511719 306.84375 L 306.847656 576.511719 C 305.015625 578.339844 302.585938 579.347656 300 579.347656 C 297.414063 579.347656 294.980469 578.339844 293.152344 576.511719 L 23.488281 306.84375 C 19.714844 303.070313 19.714844 296.929688 23.488281 293.152344 L 293.152344 23.488281 C 294.980469 21.660156 297.414063 20.652344 300 20.652344 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 172.46875 94 L 218.902344 307.40625 C 219.511719 310.867188 223.070313 312.964844 226.398438 311.820313 L 279.742188 293.464844 C 283.332031 292.226563 287.109375 294.769531 287.316406 298.558594 L 298.292969 498.828125 C 298.640625 505.179688 307.53125 506.308594 309.457031 500.25 L 403.851563 203.269531 C 405.195313 199.035156 401.414063 194.953125 397.09375 195.964844 L 326.082031 212.613281 C 321.679688 213.644531 317.878906 209.402344 319.382813 205.140625 L 366.167969 72.625 C 366.8125 70.800781 323.617188 12.890625 323.617188 12.890625 C 322.535156 11.480469 320.859375 10.652344 319.078125 10.652344 L 223.578125 10.652344 C 221.421875 10.652344 219.449219 11.863281 218.476563 13.785156 C 218.476563 13.785156 172.25 92.78125 172.46875 94 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurse);
export default __webpack_public_path__ + "static/media/Curse.56f680a9d29b9387373ae23545ddc1a0.svg";
export { ForwardRef as ReactComponent };